// @flow

import type { PendingIncomingPayment } from './types';

export function getSafeQrphQRCode(incomingPayment: PendingIncomingPayment): string {
  const QrphQRCode = incomingPayment['qrph']['qr_code_value'];
  if(!QrphQRCode){
    throw new Error('Qrph: no QR Code in incoming payment');
  }
  return QrphQRCode;
}
